export const COLUMNS_MAPPING = [
    {
        groupType: 'PRODUCT',
        columnsType: [2, 3, 4, 5, 6, 7, 8, 9, 10, 11]
    },
    {
        groupType: 'ARTICLE',
        columnsType: [19, 20, 21]
    },
    {
        groupType: 'BANNER',
        columnsType: [13, 14, 15, 16, 17, 18, 12]
    },
    {
        groupType: 'CUSTOM',
        columnsType: [1]
    }
]

export const COLUMNS_INFO = {
    1: {
        name: 'Free column',
        type: 'CUSTOM',
        image: 'free-column.jpg',
        default: {
            type: 1,
            title: 'Title',
            code: '',
            class: '',
            size: 12
        }
    },
    2: {
        name: 'Products 1',
        type: 'PRODUCT',
        image: 'products-1.jpg',
        default: {
            type: 2,
            title: 'Title',
            cat_ids: [],
            color: '',
            items_all: 8,
            items_per_row: {
                lg: 4,
                md: 3,
                xs: 2
            },
            sort_by: 'newness',
            class: '',
            size: 12
        }
    },
    3: {
        name: 'Products 2',
        type: 'PRODUCT',
        image: 'products-2.jpg',
        default: {
            type: 3,
            title: 'Title',
            cat_ids: [],
            color: '',
            items_all: 8,
            items_per_row: {
                lg: 4,
                md: 3,
                xs: 2
            },
            sort_by: 'newness',
            class: '',
            size: 12
        }
    },
    4: {
        name: 'Products 3',
        tag: 'Slider',
        type: 'PRODUCT',
        image: 'products-3.jpg',
        default: {
            type: 4,
            title: 'Title',
            cat_ids: [],
            color: '',
            rows: 1,
            autoplay: false,
            cover_image: '',
            items_all: 8,
            items_per_row: {
                lg: 4,
                md: 3,
                xs: 2
            },
            sort_by: 'newness',
            class: '',
            size: 12
        }
    },
    5: {
        name: 'Products 4',
        type: 'PRODUCT',
        tag: 'Slider',
        image: 'products-4.jpg',
        default: {
            type: 5,
            title: 'Title',
            cat_ids: [],
            color: '',
            rows: 1,
            autoplay: false,
            cover_image: '',
            items_all: 8,
            items_per_row: {
                lg: 4,
                md: 3,
                xs: 2
            },
            sort_by: 'newness',
            class: '',
            size: 12
        }
    },
    6: {
        name: 'Products 5',
        type: 'PRODUCT',
        tag: 'Slider',
        image: 'products-5.jpg',
        default: {
            type: 6,
            title: 'Title',
            cat_ids: [],
            color: '',
            rows: 1,
            autoplay: false,
            items_all: 8,
            items_per_row: {
                lg: 4,
                md: 3,
                xs: 2
            },
            sort_by: 'newness',
            class: '',
            size: 12
        }
    },
    7: {
        name: 'Products 6',
        type: 'PRODUCT',
        image: 'products-6.jpg',
        default: {
            type: 7,
            title: 'Title',
            cat_ids: [],
            color: '',
            items_all: 6,
            items_per_row: {
                lg: 3,
                md: 2,
                xs: 1
            },
            sort_by: 'newness',
            class: '',
            size: 12
        }
    },
    8: {
        name: 'Products 7',
        type: 'PRODUCT',
        tag: 'Slider',
        image: 'products-7.jpg',
        default: {
            type: 8,
            title: 'Title',
            cat_ids: [],
            color: '',
            rows: 1,
            autoplay: false,
            items_all: 6,
            items_per_row: {
                lg: 3,
                md: 2,
                xs: 1
            },
            sort_by: 'newness',
            class: '',
            size: 12
        }
    },
    9: {
        name: 'Products 8',
        type: 'PRODUCT',
        image: 'products-8.jpg',
        default: {
            type: 9,
            title: 'Title',
            cat_ids: [],
            color: '',
            cover_image: '',
            items_all: 4,
            items_per_row: {
                lg: 2,
                md: 2,
                xs: 1
            },
            sort_by: 'newness',
            class: '',
            size: 12
        }
    },
    10: {
        name: 'Products 9',
        type: 'PRODUCT',
        tag: 'Slider',
        image: 'products-9.jpg',
        default: {
            type: 10,
            title: 'Title',
            cat_ids: [],
            color: '',
            rows: 1,
            autoplay: false,
            cover_image: '',
            items_all: 4,
            items_per_row: {
                lg: 2,
                md: 2,
                xs: 1
            },
            sort_by: 'newness',
            class: '',
            size: 12
        }
    },
    11: {
        name: 'Products 10',
        type: 'PRODUCT',
        tag: 'Slider',
        image: 'products-10.jpg',
        default: {
            type: 11,
            title: 'Title',
            cat_ids: [],
            color: '',
            rows: 1,
            autoplay: false,
            cover_image: '',
            items_all: 4,
            items_per_row: {
                lg: 1,
                md: 1,
                xs: 1
            },
            sort_by: 'newness',
            class: '',
            size: 12
        }
    },
    12: {
        name: 'Banners 7',
        type: 'BANNER',
        tag: 'Slider',
        image: 'banners-7.jpg',
        default: {
            type: 12,
            title: 'Title',
            banners: [],
            max_banners: -1,
            rows: 1,
            items_per_row: {
                lg: 4,
                md: 2,
                xs: 1
            },
            autoplay: false,
            show_title: false,
            class: '',
            size: 12
        }
    },
    13: {
        name: 'Banners 1',
        type: 'BANNER',
        image: 'banners-1.jpg',
        default: {
            type: 13,
            title: 'Title',
            banners: [],
            max_banners: 3,
            class: '',
            size: 12
        }
    },
    14: {
        name: 'Banners 2',
        type: 'BANNER',
        image: 'banners-2.jpg',
        default: {
            type: 14,
            title: 'Title',
            banners: [],
            max_banners: 3,
            class: '',
            size: 12
        }
    },
    15: {
        name: 'Banners 3',
        type: 'BANNER',
        image: 'banners-3.jpg',
        default: {
            type: 15,
            title: 'Title',
            banners: [],
            max_banners: 5,
            class: '',
            size: 12
        }
    },
    16: {
        name: 'Banners 4',
        type: 'BANNER',
        image: 'banners-4.jpg',
        default: {
            type: 16,
            title: 'Title',
            banners: [],
            max_banners: 5,
            class: '',
            size: 12
        }
    },
    17: {
        name: 'Banners 5',
        type: 'BANNER',
        image: 'banners-5.jpg',
        default: {
            type: 17,
            title: 'Title',
            banners: [],
            max_banners: 4,
            class: '',
            size: 12
        }
    },
    18: {
        name: 'Banners 6',
        type: 'BANNER',
        tag: 'Unlimit',
        image: 'banners-6.jpg',
        default: {
            type: 18,
            title: 'Title',
            banners: [],
            max_banners: -1,
            items_per_row: {
                lg: 4,
                md: 2,
                xs: 1
            },
            show_title: false,
            class: '',
            size: 12
        }
    },
    19: {
        name: 'Articles 1',
        type: 'ARTICLE',
        image: 'articles-1.jpg',
        default: {
            type: 19,
            title: 'Title',
            cat_ids: [],
            color: '',
            cover_aspect_ratio: {
                width: 4,
                height: 3
            },
            items_all: 3,
            items_per_row: {
                lg: 3,
                md: 1,
                xs: 1
            },
            sort_by: 'newness',
            class: '',
            size: 12
        }
    },
    20: {
        name: 'Articles 2',
        type: 'ARTICLE',
        image: 'articles-2.jpg',
        default: {
            type: 20,
            title: 'Title',
            cat_ids: [],
            color: '',
            cover_aspect_ratio: {
                width: 1,
                height: 1
            },
            items_all: 4,
            items_per_row: {
                lg: 1,
                md: 1,
                xs: 1
            },
            sort_by: 'newness',
            class: '',
            size: 4
        }
    },
    21: {
        name: 'Articles 3',
        type: 'ARTICLE',
        image: 'articles-3.jpg',
        tag: 'Slider',
        default: {
            type: 21,
            title: 'Title',
            cat_ids: [],
            color: '',
            rows: 1,
            autoplay: false,
            cover_aspect_ratio: {
                width: 4,
                height: 3
            },
            items_all: 4,
            items_per_row: {
                lg: 3,
                md: 2,
                xs: 1
            },
            sort_by: 'newness',
            class: '',
            size: 12
        }
    }
}
